import React, { useState } from 'react'
import MenuTitle from '../../Components/MenuTitlle/MenuTitle'
import OrderHistory from '../../Components/OrderHistory/OrderHistory'
import ProductsSold from '../../Components/ProductsSold/ProductsSold'
import Style from './Repoarts.module.css'
const Repoarts = () => {
    const[checkTable,setCheckTable]=useState(false)
    return (
        <div className={Style.PageHolder}>
            <MenuTitle title={'گزارش ها'}/>
            <section className={Style.tabHolder}>
                <div className={checkTable?null:Style.onFocus} onClick={()=>setCheckTable(false)}> تاریخچه سفارش ها </div>
                <div className={checkTable?Style.onFocus:null} onClick={()=>setCheckTable(true)}>فروش محصولات</div>
            </section>
            {
                checkTable?<ProductsSold/>:<OrderHistory/>
                
            }
        </div>
    )
}

export default Repoarts
